import React from 'react';
import cx from 'classnames';
import { Consumer } from '../RadioButtonContext';
import styles from './RadioButton.module.css';
export const RadioButton = ({ id, value, disabled, children, label, className, tabIndex }) => (React.createElement(Consumer, null, ({ selectedValue, onChange, onInvalid, isValid, disabledGroup, name, required }) => {
    const radioValue = value || id;
    const radioChecked = selectedValue === radioValue;
    const radioDisabled = disabled || disabledGroup;
    const behaviors = {
        [styles.checked]: radioChecked,
        [styles.disabled]: radioDisabled
    };
    return (React.createElement("div", { className: cx(styles.container, className) },
        React.createElement("input", { type: "radio", checked: radioChecked, disabled: radioDisabled, id: id, required: required, value: radioValue, name: name, onChange: onChange, onInvalid: onInvalid, tabIndex: tabIndex, className: styles.input }),
        React.createElement("label", { htmlFor: id, "data-testid": "radio-label", className: cx(styles.label, behaviors, {
                [styles.error]: isValid !== undefined && !isValid
            }) },
            React.createElement("span", { className: cx(styles.radioButton, behaviors) }),
            (children || label) && (React.createElement("span", { className: cx(styles.labelText, behaviors, {
                    [styles.error]: isValid !== undefined && !isValid
                }) },
                label,
                typeof children !== 'function' && children,
                typeof children === 'function' &&
                    children({ isValid }))))));
}));
//# sourceMappingURL=RadioButton.js.map